import React, { ReactNode } from 'react';
import { Tabs } from 'antd';
import { RequestDetailsTabs as TabName } from 'types/requests';
import { TABS } from './utils/constants';
import './RequestDetailsDrawer.scss';

type Props = {
  activeTab: TabName,
  onChange: (tab: TabName) => void,
  overview: ReactNode,
  discussion: ReactNode,
  documents: ReactNode,
};

const RequestDetailsTabs = ({
  activeTab, onChange, overview, discussion, documents,
}: Props) => (
  <div className="request-details-drawer">
    <Tabs
      activeKey={activeTab}
      onChange={(tab) => onChange(tab as TabName)}
      items={[
        { key: TABS.overview, label: TABS.overview, children: overview },
        { key: TABS.discussionBoard, label: TABS.discussionBoard, children: discussion },
        { key: TABS.documents, label: TABS.documents, children: documents },
      ]}
    />
  </div>
);

export default RequestDetailsTabs;
